import { useEffect, useState, useRef } from "react";
import AdminTopNavBar from "../common/AdminTopNavBar";
import getUserMenuItems from "./AdminMenuContent";
import AdminSideBar from "./AdminSideBar";
import { adminReqConfig, api, baseURL } from "../../include/api";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AdminFooter from "../common/AdminFooter";
import { useNotification } from "../../Toast/ToastProvider";
import { ERROR } from "../../include/constant";
import { ChevronDown,X } from "react-feather";
import Papa from "papaparse";
import "../../styles/CategoryProductList.css";
import {
  formatMonthDateYear,
  formatShortMonthDateYear,
  getAdmin,
} from "../../include/function";
import { useSearchParams } from "react-router-dom";

const ReportCustomer = () => {
  const homeLink = "/admin";
  const [fetchLoading, setFetchLoading] = useState(true);
  const [customerList, setCustomerList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const toggleSidebar = () => setIsSidebarMinimized(!isSidebarMinimized);
  const menuContent = getUserMenuItems();
  const toast = useNotification();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const user = getAdmin();
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get("q") || "";
  const [searchQuery, setSearchQuery] = useState(initialQuery);

  useEffect(() => {
    const q = searchParams.get("q") || "";
    setSearchQuery(q);
  }, [searchParams]);
  const [productPermissions, setProductPermissions] = useState({
    add: false,
    view: false,
    edit: false,
    delete: false,
  });
  useEffect(() => {
    const fetchPermissions = async () => {
      if (!user?.roleId) return;

      try {
        const res = await api.get(
          `/role_permission/?roleId=${user.roleId}`,
          adminReqConfig()
        );
        if (res.status === 200 && Array.isArray(res.data.data)) {
          // Find permission entry where pageTitle === "Product"
          const productPerm = res.data.data.find(
            (p) => p.pageTitle === "Report Customer"
          );

          if (productPerm) {
            setProductPermissions({
              add: productPerm.add === "true" || productPerm.add === 1,
              view: productPerm.view === "true" || productPerm.view === 1,
              edit: productPerm.edit === "true" || productPerm.edit === 1,
              delete: productPerm.delete === "true" || productPerm.delete === 1,
            });
          }
        }
      } catch (err) {
        console.warn("Failed to fetch product permissions", err);
      }
    };

    fetchPermissions();
  }, [user?.roleId]);
  // Extended filter state
  const [filterValues, setFilterValues] = useState({
    customerType: "",
    customerName: "",
    createdAtFrom: "",
    createdAtTo: "",
    lastOrderFrom: "",
    lastOrderTo: "",
  });

  const filterWrapperRef = useRef(null);

  const getCategory = () => {
    setFetchLoading(true);
    Promise.all([api.get("/customer/", adminReqConfig())])
      .then(([productRes, brandRes, categoryRes]) => {
        const rawProducts = productRes.data.data || [];

        const normalizedProducts = rawProducts.map((p) => {
          return {
            ...p,
          };
        });

        setCustomerList(normalizedProducts);
        setFilteredData(normalizedProducts);
      })
      .catch((error) => {
        toast({ type: ERROR, message: "Error fetching customer data" }, error);
        setCustomerList([]);
        setFilteredData([]);
      })
      .finally(() => setFetchLoading(false));
  };

  useEffect(() => {
    getCategory();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isFilterPanelOpen &&
        filterWrapperRef.current &&
        !filterWrapperRef.current.contains(event.target)
      ) {
        setIsFilterPanelOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isFilterPanelOpen]);

  const applyFilters = () => {
    setIsFilterPanelOpen(false);
  };

  const clearFilters = () => {
    const empty = {
      customerType: "",
      customerName: "",
      createdAtFrom: "",
      createdAtTo: "",
      lastOrderFrom: "",
      lastOrderTo: "",
    };
    setFilterValues(empty);
    setIsFilterPanelOpen(false);
  };

  // Helper: compare dates (YYYY-MM-DD)
  const isDateInRange = (dateStr, from, to) => {
    if (!dateStr) return false;
    const d = new Date(dateStr.split(" ")[0]); // take only date part
    const fromDate = from ? new Date(from) : null;
    const toDate = to ? new Date(to) : null;
    return (!fromDate || d >= fromDate) && (!toDate || d <= toDate);
  };

  useEffect(() => {
    let filtered = customerList;

    if (filterValues.customerType) {
      filtered = filtered.filter(
        (p) =>
          p.customerType?.toLowerCase() ===
          filterValues.customerType.toLowerCase()
      );
    }

    if (filterValues.customerName) {
      filtered = filtered.filter(
        (p) => p.id === parseInt(filterValues.customerName)
      );
    }

    if (filterValues.createdAtFrom || filterValues.createdAtTo) {
      filtered = filtered.filter((p) =>
        isDateInRange(
          p.createdAt,
          filterValues.createdAtFrom,
          filterValues.createdAtTo
        )
      );
    }

    if (filterValues.lastOrderFrom || filterValues.lastOrderTo) {
      filtered = filtered.filter((p) =>
        isDateInRange(
          p.lastOrderDate,
          filterValues.lastOrderFrom,
          filterValues.lastOrderTo
        )
      );
    }
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      filtered = filtered.filter(
        (product) =>
          product.name?.toLowerCase().startsWith(query) ||
          product.customerType?.toLowerCase().startsWith(query)
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [filterValues, searchQuery, customerList, searchParams]);

  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;
  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = currentItems.map((p) => p.id);
      setSelectedData((prev) => [...new Set([...prev, ...allIds])]);
    } else {
      const idsToRemove = currentItems.map((p) => p.id);
      setSelectedData((prev) => prev.filter((id) => !idsToRemove.includes(id)));
    }
  };

  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

 const handleDownloadCSV = (exportScope = "current") => {
  let dataToExport = [];

  // ✅ PRIORITY 1: If items selected → ALWAYS export selected (overrides everything)
  if (selectedData.length > 0) {
    dataToExport = customerList.filter((p) => selectedData.includes(p.id));
  } 
  // ✅ PRIORITY 2: If "Export All" clicked → export entire dataset
  else if (exportScope === "all") {
    dataToExport = customerList;
  } 
  // ✅ PRIORITY 3: Default → export current page items only
  else {
    dataToExport = currentItems;
  }

  if (dataToExport.length === 0) {
    toast({ type: "error", message: "No customer data to download" });
    return;
  }

  const productColumns = [
    "S.No",
    "Cust ID",
    "Customer Type",
    "Customer Name",
    "Email",
    "Alternative Email",
    "Phone",
    "Alternative Phone",
    "Address",
    "Locality",
    "Landmark",
    "City",
    "State",
    "Pincode",
    "GST No",
    "Status",
    "Total Transaction",
    "Total Orders",
    "Created Date",
    "Last Order Date",
  ];
  const csvData = dataToExport.map((p, i) => {
    const addr = p.addressList?.[0] || {};
    const gstProof = p.proof?.find((pr) => pr.proofName === "gstCertificate");
    const gstNo = gstProof?.gstNo || "-";

    return {
      "S.No": i + 1,
      "Cust ID": formatCustomerId(p),
      "Customer Type": p.customerType || "-",
      "Customer Name": p.name || "-",
      Email: p.emailId || "-",
      "Alternative Email": p.alternativeEmailId || "-",
      Phone: p.phoneNumber || "-",
      "Alternative Phone": p.alternativePhoneNumber || "-",
      Address: addr.address || p.address1 || "-",
      Locality: addr.locality || "-",
      Landmark: addr.landmark || "-",
      City: addr.city || "-",
      State: addr.state || "-",
      Pincode: p.pincode || addr.pin || "-",
      "GST No": gstNo,
      Status: p.status || "-",
      "Total Transaction": p.totalTransaction || "0",
      "Total Orders": p.totalOrders || "0",
      "Created Date": p.createdAt
        ? formatShortMonthDateYear(p.createdAt)
        : "-",
      "Last Order Date": p.lastOrderDate
        ? formatShortMonthDateYear(p.lastOrderDate)
        : "-",
    };
  });

  // ✅ CRITICAL FIX: The word "data" followed by colon, then the mapping
  const csv = Papa.unparse({
    fields: productColumns,
    data: csvData.map(function(row) {
      return productColumns.map(function(col) {
        return row[col];
      });
    }),
  });

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  
  // ✅ Dynamic filename based on export type
  const fileName = selectedData.length > 0 
    ? `Customer_Selected_${selectedData.length}.csv`
    : exportScope === "all" 
      ? "Customer_All.csv" 
      : `Customer_Page${currentPage}.csv`;
    
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  const generateCustomerPDF = async (cust) => {
    const doc = new jsPDF();
    const titleY = 20;
    doc.setFontSize(16);
    doc.text(`Customer Report: ${cust.name || "N/A"}`, 14, titleY);
    doc.setFontSize(10);

    const addr = cust.addressList?.[0] || {};
    const gstProof = cust.proof?.find(
      (pr) => pr.proofName === "gstCertificate"
    );
    const gstNo = gstProof?.gstNo || "-";

    const tableData = [
      ["Field", "Value"],
      ["Cust ID", formatCustomerId(cust)],
      ["Customer Type", cust.customerType || "-"],
      ["Customer Name", cust.name || "-"],
      ["Email", cust.emailId || "-"],
      ["Alternative Email", cust.alternativeEmailId || "-"],
      ["Phone", cust.phoneNumber || "-"],
      ["Alternative Phone", cust.alternativePhoneNumber || "-"],
      ["Address", addr.address || cust.address1 || "-"],
      ["Locality", addr.locality || "-"],
      ["Landmark", addr.landmark || "-"],
      ["City", addr.city || "-"],
      ["State", addr.state || "-"],
      ["Pincode", cust.pincode || addr.pin || "-"],
      ["GST No", gstNo],
      ["Status", cust.status || "-"],
      ["Total Transaction", cust.totalTransaction?.toString() || "0"],
      ["Total Orders", cust.totalOrders?.toString() || "0"],
      [
        "Created Date",
        cust.createdAt ? formatShortMonthDateYear(cust.createdAt) : "-",
      ],
      [
        "Last Order Date",
        cust.lastOrderDate ? formatShortMonthDateYear(cust.lastOrderDate) : "-",
      ],
    ];

    const tableStartY = titleY + 10;
    autoTable(doc, {
      startY: tableStartY,
      head: [["Field", "Value"]],
      body: tableData.slice(1),
      theme: "grid",
      styles: { fontSize: 10, cellPadding: 1.5 },
      headStyles: { fillColor: [43, 149, 211], fontSize: 11 },
      columnStyles: {
        0: { cellWidth: 60, fontStyle: "bold" },
        1: { cellWidth: 130, overflow: "linebreak" },
      },
      margin: { left: 14, right: 14 },
    });

    const finalY = doc.previousAutoTable.finalY + 10;
    const timestamp = `Generated on: ${new Date().toLocaleString("en-IN", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    })}`;
    if (finalY > 270) {
      doc.addPage();
      doc.text(timestamp, 14, 20);
    } else {
      doc.text(timestamp, 14, finalY);
    }

    const safeName = (cust.name || "customer")
      .replace(/\s+/g, "_")
      .replace(/[^a-zA-Z0-9_-]/g, "");
    doc.save(`Customer_${cust.id}_${safeName}.pdf`);
  };

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => {
      const updated = { ...prev, [key]: value };
      if (key === "categoryId") {
        updated.brandId = "";
        updated.productId = "";
      } else if (key === "brandId") {
        updated.productId = "";
      } else if (key === "customerType") {
        updated.customerName = "";
      }
      return updated;
    });
  };
  const formatCustomerId = (customer) => {
    if (!customer?.createTimestamp || !customer?.id) return "CUS--";

    // Extract last 2 digits of year
    const year = new Date(customer.createTimestamp).getFullYear();
    const yy = String(year).slice(-2); // e.g., 2025 → "25"

    // Zero-pad order.id to 4 digits
    const paddedId = String(customer.id).padStart(4, "0"); // e.g., 7 → "0007"

    return `CUS${yy}-${paddedId}`;
  };

  return (
    <>
      <AdminSideBar
        menuContent={menuContent}
        isMinimized={isSidebarMinimized}
      />
      <AdminTopNavBar
        toggleSidebar={toggleSidebar}
        isSidebarMinimized={isSidebarMinimized}
        homeLink={homeLink}
        title="REPORTS"
      />
      <div
        className="content-wrapper p-0"
        style={{
          marginLeft: isSidebarMinimized ? "80px" : "250px",
          flex: "1",
        }}
      >
        <section
          style={{
            backgroundColor: "#F1F4F9",
            padding: "30px",
            marginTop: "70px",
            marginBottom: "40px",
            minHeight: "80vh",
          }}
        >
          {fetchLoading ? (
            <p>Loading customers...</p>
          ) : (
            <>
              <div className="rounded-5 bg-white py-24 ">
                <div className="row align-items-center px-24 py-10 mb-3">
                  <div className="col-auto">
                    <h6 className="mb-0">Customer List</h6>
                  </div>
                  <div className="col d-flex align-items-center">
                    <div
                      className="filter-wrapper"
                      style={{ position: "relative", width: "500px" }}
                      ref={filterWrapperRef}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #c6d6f5",
                          borderRadius: "8px",
                          backgroundColor: "#fff",
                          width: "100%",
                        }}
                      >
                        <img
                          src="/assets/images/search-icon.png"
                          style={{ width: "18px", marginLeft: "8px" }}
                        />
                        <input
                          type="text"
                          placeholder="Filter and Search here..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          onFocus={() => setIsFilterPanelOpen(true)}
                          style={{
                            border: "none",
                            outline: "none",
                            padding: "8px 8px",
                            width: "100%",
                            fontSize: "14px",
                            color: "#333",
                            backgroundColor: "transparent",
                          }}
                        />
                        {searchQuery && (
                          <X
                            size={24}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSearchQuery("");
                              setCurrentPage(1);
                              setIsFilterPanelOpen(false);
                            }}
                            style={{
                              position: "absolute",
                              right: "40px",
                              cursor: "pointer",
                              color: "#999",
                              padding: "4px",
                              zIndex: 10,
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.color = "#666")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.color = "#999")
                            }
                          />
                        )}
                        <ChevronDown
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#999",
                            cursor: "pointer",
                            transform: isFilterPanelOpen
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.2s",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsFilterPanelOpen(!isFilterPanelOpen);
                          }}
                        />
                      </div>

                      {isFilterPanelOpen && (
                        <FilterPanel
                          filterValues={filterValues}
                          onFilterChange={handleFilterChange}
                          onApply={applyFilters}
                          onClear={clearFilters}
                          customerList={customerList}
                          onClick={(e) => e.stopPropagation()}
                        />
                      )}
                    </div>
                  </div>
                  <div className="d-flex col-auto">
                    <div className="">
                      <CustomDropdown handleDownloadCSV={handleDownloadCSV} />
                    </div>
                  </div>
                </div>
                {/* Table */}
                <div className="table-responsive mt-24 product-table">
                  <table className="table table-striped custom-striped-table-product-list align-middle">
                    <thead className="">
                      <tr>
                        <th scope="col" style={{ width: "50px" }}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ borderColor: "#c5d5f5" }}
                            onChange={handleSelectAll}
                            checked={
                              currentItems.length > 0 &&
                              currentItems.every((p) =>
                                selectedData.includes(p.id),
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Cust.ID
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Customer Type
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Customer Name
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Total Transaction
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Total Orders
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Created Date
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Last Order Date
                        </th>
                        <th
                          scope="col"
                          style={{
                            width: "120px",
                            fontSize: "15px",
                          }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((product) => {
                          return (
                            <tr key={product.id}>
                              <td>
                                <input
                                  type="checkbox"
                                  style={{ borderColor: "#c5d5f5" }}
                                  className="form-check-input"
                                  checked={selectedData.includes(product.id)}
                                  onChange={() => handleSelectOne(product.id)}
                                />
                              </td>
                              <td
                                style={{
                                  textWrap: "nowrap",
                                  overflow: "hidden",
                                }}
                              >
                                {formatCustomerId(product)}
                              </td>
                              <td className="text-capitalize">
                                {product.customerType || ""}
                              </td>
                              <td>{product.name || ""}</td>
                              <td>{product.totalTransaction || ""}</td>
                              <td>{product.totalOrders || ""}</td>
                              <td>
                                {product.createdAt
                                  ? formatShortMonthDateYear(product.createdAt)
                                  : ""}
                              </td>
                              <td>
                                {product.lastOrderDate
                                  ? formatShortMonthDateYear(
                                      product.lastOrderDate,
                                    )
                                  : ""}
                              </td>
                              <td style={{ position: "relative" }}>
                                <div className="d-flex gap-1">
                                  <button
                                    style={{
                                      backgroundColor: "#D9EBFF",
                                      height: "36px",
                                      width: "70px",
                                      border: "none",
                                      borderRadius: "4px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      padding: "0",
                                      margin: "0",
                                      fontSize: "14px",
                                      lineHeight: 1,
                                      outline: "none",
                                      fontWeight: "600",
                                      color: "#2B95D3",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      generateCustomerPDF(product, baseURL);
                                    }}
                                  >
                                    <img
                                      src="/assets/images/download-icon.png"
                                      alt="download"
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        objectFit: "contain",
                                      }}
                                      onError={(e) =>
                                        (e.target.style.display = "none")
                                      }
                                    />
                                    {`\u00A0\u00A0\u00A0PDF`}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            No customers found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-16 p-16">
                  <div className="d-flex align-items-center">
                    <select
                      className="form-select d-inline-block w-auto"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const val = e.target.value;
                        setItemsPerPage(val === "all" ? "all" : parseInt(val));
                        setCurrentPage(1);
                      }}
                      style={{
                        height: "34px",
                        fontSize: "14px",
                        minWidth: "70px",
                      }}
                    >
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="all">All</option>
                    </select>
                    <span className="ms-2">
                      Showing {showingFrom} to {showingTo} of{" "}
                      {filteredData.length} Lists
                    </span>
                  </div>
                  <nav>
                    <ul className="pagination mt-0">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          &laquo;
                        </button>
                      </li>
                      {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(
                          1,
                          currentPage - Math.floor(pagesToShow / 2),
                        );
                        let endPage = startPage + pagesToShow - 1;
                        if (endPage > totalPage) {
                          endPage = totalPage;
                          startPage = Math.max(1, endPage - pagesToShow + 1);
                        }
                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                          pageNumbers.push(i);
                        }
                        return pageNumbers.map((pageNum) => (
                          <li
                            key={pageNum}
                            className={`page-item ${
                              currentPage === pageNum ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => paginate(pageNum)}
                            >
                              {pageNum}
                            </button>
                          </li>
                        ));
                      })()}
                      <li
                        className={`page-item ${
                          currentPage === totalPage ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          &raquo;
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </>
          )}
          <AdminFooter isSidebarMinimized={isSidebarMinimized} />
        </section>
      </div>
    </>
  );
};

export default ReportCustomer;

const CustomDropdown = ({ handleDownloadCSV }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Options");
  const dropdownRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  const options = [
    { label: "Export", value: "export" },
    { label: "Export All", value: "exportAll" },
  ];

const handleSelect = (opt) => {
  setSelected(opt.label);
  setIsOpen(false);
  
  if (opt.value === "export") {
    // ✅ Export = current page only (but selected overrides)
    handleDownloadCSV("current");
  } else if (opt.value === "exportAll") {
    // ✅ Export All = entire dataset (but selected overrides)
    handleDownloadCSV("all");
  }
  
  setSelected("Options");
};

  // 👇 Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div
      className="custom-select"
      style={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef} // 👈 attach ref to the container
    >
      <div
        className="select-header"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: isHovered ? "#EDF8FA" : "#fff",
          color: "rgba(129, 134, 134, 1)",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          width: "140px",
          height: "40px",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 500,
          transition: "background-color 0.2s ease",
        }}
      >
        <span>{selected}</span>
        <ChevronDown />
      </div>
      {isOpen && (
        <ul
          className="select-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            backgroundColor: "white",
            border: "none",
            borderRadius: "4px",
            zIndex: 1000,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: 500,
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              onClick={() => handleSelect(opt)}
              className="select-option"
              style={{
                padding: "8px 12px",
                color: "rgba(129, 134, 134, 1)",
                backgroundColor: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const FilterPanel = ({
  filterValues,
  onFilterChange,
  onApply,
  onClear,
  customerList,
  onClick,
}) => {
  // Filter customers by selected type
  const filteredCustomers = filterValues.customerType
    ? customerList.filter(
        (c) =>
          c.customerType?.toLowerCase() ===
          filterValues.customerType.toLowerCase()
      )
    : customerList;

  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "500px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
        padding: "16px",
        maxHeight: "600px",
        overflowY: "auto",
        marginTop: "10px",
      }}
      onClick={onClick}
    >
      <div className="row g-3">
        {/* Customer Type */}
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.customerType}
            onChange={(e) => onFilterChange("customerType", e.target.value)}
          >
            <option value="">Customer Type</option>
            {[
              ...new Set(
                customerList.map((c) => c.customerType).filter(Boolean)
              ),
            ].map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Customer Name (filtered by type) */}
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.customerName}
            onChange={(e) => onFilterChange("customerName", e.target.value)}
          >
            <option value="">Customer Name</option>
            {filteredCustomers.map((customer) => (
              <option key={customer.id} value={customer.id}>
                {customer.name}
              </option>
            ))}
          </select>
        </div>

        <h6 className="fs-6 mb-0">Based on Create Date</h6>
        {/* Created At From/To */}
        <div className="col-md-6">
          <input
            type="date"
            className="form-control filter-input"
            value={filterValues.createdAtFrom}
            onChange={(e) => onFilterChange("createdAtFrom", e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <input
            type="date"
            className="form-control filter-input"
            value={filterValues.createdAtTo}
            onChange={(e) => onFilterChange("createdAtTo", e.target.value)}
          />
        </div>

        <h6 className="fs-6 mb-0">Based on Last Order Date</h6>
        {/* Last Order From/To */}
        <div className="col-md-6">
          <input
            type="date"
            className="form-control filter-input"
            value={filterValues.lastOrderFrom}
            onChange={(e) => onFilterChange("lastOrderFrom", e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <input
            type="date"
            className="form-control filter-input"
            value={filterValues.lastOrderTo}
            onChange={(e) => onFilterChange("lastOrderTo", e.target.value)}
          />
        </div>
      </div>
      <div className="d-flex gap-14 mt-24">
        <button
          onClick={onApply}
          style={{
            color: "#fff",
            backgroundColor: "#2b95d3",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
          }}
        >
          Apply Filters
        </button>
        <button
          onClick={onClear}
          style={{
            color: "#2692d2",
            backgroundColor: "#d9ebff",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
            gap: "6px",
          }}
        >
          Clear All
        </button>
      </div>
    </div>
  );
};
